export default {
  // 業務工作流
  businessFlow: {
    bussinessFlowInof: '業務流程信息',
    flowStatus: '流程狀態',
    status: '狀態',
    beginTime: '發起時間',
    creater: '創建人',
    bussinessFlowPic: '業務流程圖',
    flowRecord: '流程記錄',
    completeTask: '完成了任務',
    HhaveInHand: '進行中',
    yistop: '已終止',
    yicompleted: '已完成',
    yidelete: '已刪除',
    agreeOrDisagree: '同意/不同意',
    businessFlow: '業務流程',
    businessFlowInfo1: '流程信息',
    approvalPass: '審批通過',
    approvalReject: '審批駁回',
    approvaling: '審批中',
    approvalResult: '審批結果',
    taskUpdatePer: '此任務需要變更負責人',
    taskAddOrReferenceData: '此任務需要新增或關聯數據',
    taskAddData: '此任務需要新增數據',
    agree: '同意',
    disagree: '不同意',
    inputContent: '填寫意見',
    completedTask: '完成任務',
    completeTaskBefore: '完成此任務前需要為下壹個任務選擇執行人',
    auth: '權限',
    selectPerOverPer: '所選人員覆蓋下壹任務預置執行人',
    selectperAdd: '所選人員添加到下壹任務的執行人中',
    handlePer: '處理人',
    selectExecutor: '請選擇執行人',
    changeExecutor: '更換執行人成功',
    selectLeader: '請選擇負責人',
    selectNextTaskExecutor: '請選擇下壹任務執行人',
    guanlianDataSUccess: '關聯數據成功',
    updateLeaderSuccess: '變更負責人成功',
    approvalSuccess: '審批完成',
    input: '填寫',
    updataLeader: '變更負責人',
    resetBussinessflow: '重置業務流程完成',
    stopBussinessflow: '終止業務流程完成',
    startBussinessflow: '重啟業務流程完成',
    changeHandlePer: '更換執行人',
    reset: '重置',
    currentVersion: '當前版本',
    LatestVedition: '最新版本',
    stop: '終止',
    enable: '啟用',
    temporaryStorage: '暫存',
    saveAndEnable: '保存並啟用',
    businessNode: '業務節點',
    baseNode: '基礎節點',
    start: '開始',
    flowColor: '流程顏色',
    selectColor: '選擇顏色',
    customColor: '自定義顏色',
    color: '顏色',
    addStage: '添加階段',
    businessName: '業務名稱',
    gouxuan1: '勾選則代表前置所有節點分支都完成後才創建當前業務活動',
    gouxuan2: '不勾反之，後續業務活動會存在多個處理',
    beforeCompleteTask: '再前置節點都完成後才能生成當前業務活動',
    describe: '描述',
    befroreTaskChooseOne: '對前置業務活動中的哪壹條數據執行操作',
    executionOperation: '執行操作',
    guanlianModule: '關聯模塊',
    yunxuAdd: '只允許新建不能關聯已有數據',
    oprationContent: '操作內容',
    oprationBtnName: '操作按鈕名稱',
    approvalBusinessData: '審批業務數據',
    selectApprovaler: '選擇審批人',
    nodeCompleteNextPer: '節點完成時，執行人可指定下壹節點執行人',
    approvalContent: '審批內容',
    editFields: '編輯字段',
    addField: '添加字段',
    businessExecutor: '該業務執行人',
    approvalCondition: '審批條件',
    afterIn: '後進入',
    stageStopTime: '階段停留時間',
    stopTingliu: '限制停留',
    afterChaoshi: '後超時',
    chaoshiRemind: '超時提醒',
    afterRemind: '後提醒',
    remindPer: '提醒人員',
    addRemind: '添加提醒',
    nodeBreanchJudage: '節點分支判斷',
    condtionIn: '滿足條件進入',
    addBrenchCondition: '添加分支條件',
    notInCondition: '不滿足以上條件進入',
    stage: '階段',
    stageName: '階段名稱',
    proventNodeData: '上壹個節點的數據',
    beforeChaoshi: '超時前',
    afterChaoshi1: '超時後',
    completeAfter: '完成後',
    addOrGuanlianData: '新建或關聯模塊數據',
    judge1: '請優先選擇對前置業務活動中的哪壹條數據執行操作',
    judge2: '該節點缺少壹條連入的線',
    judge3: '節點未選擇前置業務數據',
    oneStage: '第壹階段',
    businessHuodong: '業務活動',
    end: '結束',
    di: '第',
    dontDelStartNode: '不能刪除開始節點',
    initNodeDontDel: '初始化的階段不能刪除',
    approvalNode: '審批節點',
    breanchNode: '分支節點',
    judge4: '該節點有且只能有兩根連出的線',
    judge5: '階段名稱必填',
    judge6: '至少有壹個業務活動節點',
    judge7: '至少有壹個結束節點',
    judge8: '不能為空',
    judge9: '節點，必須在階段內',
    judge10: '節點，兩個相同的節點之間不能有超過壹條以上的連接線',
    judge11: '【開始】節點，有且只有壹條連出的線',
    judge12: '節點，至少有壹條連入的線',
    judge13: '節點，至少有壹條連出的線',
    judge14: '【結束】節點，至少有壹條連入的線',
    judge15: '節點，有且只有壹條連入的線',
    judge16: '節點，有且只有兩條連出的線',
    judge17: '節點，至少有兩條連出的線',
    judge18: '分支節點之間不能直接連接',
    judge19: '節點名稱必填',
    judge20: '節點，未選擇對前置業務活動中的哪壹條數據執行操作',
    judge21: '節點，關聯模塊必填',
    judge22: '節點，至少選擇壹個編輯字段',
    judge23: '節點，操作按鈕名稱必填',
    judge24: '節點，業務執行人必填',
    judge25: '節點，審批人必填',
    judge26: '節點，審批條件有誤',
    judge27: '節點，分支判斷有誤',
    judge28: '節點，請選擇不滿足以上條件進入的節點',

    // 2020-10-15
    currentProcess: '當前流程',
    resetRecord: '重置記錄',
    resetList: '重置列表',
    processName: '流程名稱',
    completionTime: '完成時間',
    gouxuan3: '勾選後後置節點不允許返回連接當前節點及之前節點',
    gouxuan4: '在前置節點都完成後才能生成當前業務活動',
    beforBusinessOpertion: '對前置業務活動中的哪壹個節點執行操作',
    moreZhixMemberInfo: '多個執行人處理方式',
    approval: '審批',
    delBusinessFolw: '確定要刪除業務流程嗎?',
    yingxiangInfo1: '當前操作將影響',
    yingxiangInfo2: '設置將被清空，需重新去設置，確定要操作嗎?',
    pleaseChooseOp: '請選擇執行操作',
    qianzhi: '前置',
    zhixingUp: '執行人上級',
    newJiedduan: '新階段',
    judge29: '勾選了前置完成，不允許後置節點返回當前節點及之前節點',
    judge30: '不允許連接到',
    judge31: '該場景暫不支持',
    judge32: '節點錯誤配置，不允許連接結束又連接其他節點',
    judge33: '節點配置錯誤，請正確連接',
    judge34: '分支錯誤配置，不允許',
    judge35: '連接結束又',
    judge36: '連接其他業務節點',
    judge37: '分支錯誤配置，不允許連接結束節點的條件和連接其他節點條件相同',

    // 2020-12-28
    submitBusinessForyouHandle: '提交的業務流程需要您處理',
    stageNameCustomComponent: '階段名稱賦值至自定義組件',
    customComponentStageName: '字段組件賦值階段名稱',
    passRemark: '通過意見',
    rejectRemark: '駁回意見',
    viewApprovalData: '查看審批數據',
    dataCreatedAwaitingApproval: '數據已新建提交，等待審批中...',
    dataBeenRejectedCreated: '數據被"審批駁回"，請重新創建數據或查看審批數據。',
    showFillingInstructions: '操作中顯示填寫說明',
    currentModuleHasApprovalFlow: '當前模塊存在審批流程，審批通過後節點才算已完成',
    pendingApprovalUp: '待審批遞補，若上級空缺系統自動向上遞補',
    emailsSenderPass: '發件人的郵件地址必須是驗證通過的，若未綁定驗證通過則郵件不會發送',
    processAdvice: '流程意見',
    maxLength500: '最大輸入500個文字'
  }
}
